import { useMemo } from 'react';
import { FeatureFlag } from "..";
import { useCurrentUser } from "./use-current-user";

export function useFeature(featureName: string) {
    const user = useCurrentUser();
    const flags = user?.feature_flags as FeatureFlag[] | undefined;

    return useMemo(() => {
        if (!Array.isArray(flags)) return false;
        const flag = flags.find((f) => f.feature_name === featureName);
        return Boolean(flag?.enabled);
    }, [flags, featureName]);
}
